import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const handleClick = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <div className="nav-wrapper">
      <nav className="navigation">
        <Link
          onClick={() => {
            setIsOpen(false);
            handleClick("/");
          }}
          to="/"
          className="logo"
        >
          Logo
        </Link>

        <div
          className={`hamburger ${isOpen ? "active" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        <ul className={`nav-menu ${isOpen ? "active" : ""}`}>
          <div className="nav-menu-logo">Logo</div>
          <li>
            <Link
              className="menu-name"
              to="/"
              onClick={() => {
                setIsOpen(false);
                handleClick("/");
              }}
            >
              Naslovna
            </Link>
          </li>{" "}
          <li>
            <Link
              className="menu-name"
              to="/kuhani-gablec-meni"
              onClick={() => {
                setIsOpen(false);
                handleClick("/kuhani-gablec-meni");
              }}
            >
              Kuhani gableci
            </Link>
          </li>
          <li>
            <Link
              className="menu-name"
              to="/meni"
              onClick={() => {
                setIsOpen(false);
                handleClick("/meni");
              }}
            >
              Meni
            </Link>
          </li>
          {/*         <li>
            <Link
              className="menu-name"
              to="/kontakt"
              onClick={() => {
                setIsOpen(false);
                handleClick("/kontakt");
              }}
            >
              Kontakt
            </Link>
          </li> */}
          <div className="social-media-nav">
            <i class="fi fi-brands-instagram"></i>
            <i class="fi fi-brands-facebook"></i>
          </div>
        </ul>
      </nav>

      <div className="order-nav">
        <a href="tel:/">
          <i className="fi fi-bs-phone-call"></i> Naručite: 091 1234 567
        </a>
      </div>
    </div>
  );
};

export default Navigation;
